(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('teamList', function ($Teams, ModalService, $rootScope, $uibModal) {
		return {
			scope: {},
			templateUrl: 'directives/teamList/table.html',
			link: function() {},
			controller: function($scope) {
				/* Paging items. */
                $scope.teams = $Teams.all();
				// $scope.teams = $pageArray($Teams.ref, 'name');

				$scope.search = { name: ''};

				/* Function to provide the option to delete an existing product. */
				$scope.delete = function (team) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Delete "${team.name}"?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, team) {

                            $scope.delete = function () {

                                scope.teams.$remove(team);

                                $uibModalInstance.close(team);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            team: function() {
                                return team;
                            }
                        },
                        // size: 'sm'
                    });


		    	};

				$scope.copy = function(team) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Copy "${team.name}"?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="copy()">Copy</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, team) {

                            $scope.copy = function () {

                                let teamCopy = angular.copy(team);

                                teamCopy.name = 'Copy of ' + teamCopy.name;

            					scope.teams.$add(teamCopy);

                                $uibModalInstance.close(team);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            team: function() {
                                return team;
                            }
                        }
                        // size: 'sm'
                    });


				};

				$scope.add = function () {
		            var scope = $rootScope.$new();
		            scope.title = 'Add a New team';

		            var modal = ModalService.showModal({
						templateUrl: 'directives/teamList/modal.html',
						scope: scope,
						controller: function($element, close) {

                            scope.team = {};

                            scope.schema = {
                                type: 'object',
                                properties: {
                                //   teamId: {
                                //       type: 'string',
                                //       minLength: 2,
                                //       title: 'Team Id',
                                //       description: 'Team Id Number',
                                //       placeholder: 'Enter Team Id'
                                //   },
                                  name: {
                                    type: 'string',
                                    title: 'Team Name',
                                    description: 'Display name for the team',
                                    placeholder: 'Enter Team Name'
                                  }
                                },
                                //required: [ 'teamId', 'name' ]
                                required: [ 'name' ]
                              };

                              scope.form = [
                                '*',
                                {
                                  type: 'submit',
                                  title: 'Add',
                                }
                              ];

                              scope.submitForm = function(form) {
                                  // First we broadcast an event so all fields validate themselves
                                  $scope.$broadcast('schemaFormValidate');

                                  // Then we check if the form is valid
                                  if (form.$valid) {
                                    $scope.teams.$add(scope.team);
      		                        $element.modal('hide');
      		                        close(null, 1000);
                                  }
                              };

						}
					}).then(function(modal) {
		                modal.element.modal();
						modal.close.then(function(result) {});
					});
		    	};

		    	$scope.edit = function (item) {
		            var scope = $rootScope.$new();
		            scope.title = 'Edit a team';
		            scope.team = item;

		            var modal = ModalService.showModal({
		                templateUrl: 'directives/teamList/modal.html',
		                scope: scope,
						controllerAs: 'ctrl',
		                controller: function($element, close) {

                            scope.schema = {
                                type: "object",
                                properties: {
                                //   teamId: {
                                //       type: 'string',
                                //       minLength: 2,
                                //       title: 'Team Id',
                                //       description: 'Team Id Number',
                                //       placeholder: 'Enter Team Id'
                                //   },
                                  name: {
                                    type: 'string',
                                    title: 'Team Name',
                                    description: 'Display name for the team',
                                    placeholder: 'Enter Team Name'
                                  }
                                },
                                required: [ 'name' ]
                                // required: [ 'teamId', 'name' ]
                              };

                              scope.form = [
                                "*",
                                {
                                  type: 'submit',
                                  title: 'Save',
                                  style: 'btn-primary'
                                }
                              ];

                              scope.submitForm = function(form) {
                                  // First we broadcast an event so all fields validate themselves
                                  $scope.$broadcast('schemaFormValidate');

                                  // Then we check if the form is valid
                                  if (form.$valid) {
                                    $scope.teams.$save(scope.team);
      		                        $element.modal('hide');
      		                        close(null, 1000);
                                  }
                              };
		                }
		            }).then(function(modal) {
		                modal.element.modal();
		                modal.close.then(function(result) {});
		            });
		    	};

			}
		};

	});
})();
